// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1vmlF","row":"ProcedureTreatmentSummary_row__2gI0p"};